var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('Navbar')],1),_vm._v(" "),_c('main',[_c('div',{staticClass:"uk-container-center uk-margin-medium-bottom mt20"},[_c('RouterView')],1)]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }